<template>
  <main class="pt-16 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-100 min-h-screen">
    <div class="w-full py-6 sm:py-8 lg:py-16">
      <div class="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <h1 class="text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-gray-900 mb-2 sm:mb-4 text-center px-2">
          Produits éligibles à l'offre de remboursement
        </h1>
        <p class="text-sm sm:text-base text-gray-600 text-center mb-6 sm:mb-8 lg:mb-12 px-2">
          Retrouvez ci-dessous la liste des références éligibles à l'offre de remboursement Redmi Note 15
        </p>

        <!-- Récapitulatif des offres (en haut sur mobile) -->
        <div class="mb-6 sm:mb-8 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
          <div
            v-for="offer in offers"
            :key="offer.model"
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-6 text-center shadow-md border-l-4 border-orange-500"
          >
            <p class="text-xs sm:text-sm text-gray-600 mb-1 truncate">{{ offer.model }}</p>
            <p class="text-xl sm:text-2xl md:text-3xl font-bold text-orange-500">{{ offer.refund }}€</p>
            <p class="text-xs text-gray-500">remboursés</p>
          </div>
        </div>

        <!-- Vue mobile : Cartes par modèle -->
        <div class="md:hidden space-y-4">
          <div
            v-for="(group, modelName) in groupedProducts"
            :key="modelName"
            class="bg-white rounded-xl shadow-md overflow-hidden"
          >
            <!-- En-tête du modèle -->
            <div class="bg-gray-900 text-white px-4 py-3 flex justify-between items-center">
              <h3 class="font-semibold text-sm">{{ modelName }}</h3>
              <span class="bg-orange-500 text-white font-bold px-3 py-1 rounded-full text-sm">
                {{ group.refund }}€
              </span>
            </div>
            <!-- Liste des variantes -->
            <div class="divide-y divide-gray-100">
              <div
                v-for="product in group.products"
                :key="product.ean"
                class="px-4 py-3 flex items-center justify-between"
              >
                <div class="flex items-center gap-3">
                  <span
                    class="w-4 h-4 rounded-full border border-gray-300 flex-shrink-0"
                    :style="{ backgroundColor: getColorCode(product.color) }"
                  ></span>
                  <div>
                    <p class="text-sm font-medium text-gray-900">{{ product.color }}</p>
                    <p class="text-xs text-gray-500">{{ product.memory }}Go / {{ product.storage }}Go</p>
                  </div>
                </div>
                <p class="text-xs text-gray-400 font-mono">{{ product.ean }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Vue desktop : Tableau -->
        <div class="hidden md:block bg-white rounded-xl shadow-lg overflow-hidden">
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead class="bg-gray-900 text-white">
                <tr>
                  <th class="px-4 py-3 text-left text-sm font-semibold">Modèle</th>
                  <th class="px-4 py-3 text-left text-sm font-semibold">Mémoire</th>
                  <th class="px-4 py-3 text-left text-sm font-semibold">Stockage</th>
                  <th class="px-4 py-3 text-left text-sm font-semibold">EAN</th>
                  <th class="px-4 py-3 text-left text-sm font-semibold">Coloris</th>
                  <th class="px-4 py-3 text-right text-sm font-semibold">Remboursement</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <template v-for="(group, modelName) in groupedProducts">
                  <tr
                    v-for="(product, index) in group.products"
                    :key="product.ean"
                    :class="[
                      index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                      'hover:bg-orange-50 transition-colors'
                    ]"
                  >
                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                      <span v-if="index === 0" class="block">{{ modelName }}</span>
                      <span v-else class="text-gray-400">↳</span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                      {{ product.memory }} Go
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                      {{ product.storage }} Go
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-500 font-mono">
                      {{ product.ean }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                      <span class="inline-flex items-center gap-2">
                        <span
                          class="w-3 h-3 rounded-full border border-gray-300"
                          :style="{ backgroundColor: getColorCode(product.color) }"
                        ></span>
                        {{ product.color }}
                      </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-right">
                      <span
                        v-if="index === 0"
                        class="inline-block bg-orange-500 text-white font-bold px-3 py-1 rounded-full"
                      >
                        {{ group.refund }}€
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "ProduitsEligiblesView",
  data() {
    return {
      products: [
        { model: "REDMI Note 15 Pro+ 5G", memory: 12, storage: 512, ean: "6932554468040", color: "Noir", refund: 50 },
        { model: "REDMI Note 15 Pro+ 5G", memory: 12, storage: 512, ean: "6932554481841", color: "Moka", refund: 50 },
        { model: "REDMI Note 15 Pro+ 5G", memory: 12, storage: 512, ean: "6932554481971", color: "Bleu", refund: 50 },
        { model: "REDMI Note 15 Pro+ 5G", memory: 8, storage: 256, ean: "6932554490133", color: "Noir", refund: 50 },
        { model: "REDMI Note 15 Pro+ 5G", memory: 8, storage: 256, ean: "6932554481605", color: "Moka", refund: 50 },
        { model: "REDMI Note 15 Pro+ 5G", memory: 8, storage: 256, ean: "6932554490126", color: "Bleu", refund: 50 },
        { model: "REDMI Note 15 Pro 5G", memory: 12, storage: 512, ean: "6932554471644", color: "Noir", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 12, storage: 512, ean: "6932554470142", color: "Gris Titane", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 12, storage: 512, ean: "6932554470074", color: "Bleu", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 512, ean: "6932554478636", color: "Noir", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 512, ean: "6932554478612", color: "Gris Titane", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 512, ean: "6932554478605", color: "Bleu", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 256, ean: "6932554471521", color: "Noir", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 256, ean: "6932554470401", color: "Gris Titane", refund: 40 },
        { model: "REDMI Note 15 Pro 5G", memory: 8, storage: 256, ean: "6932554470500", color: "Bleu", refund: 40 },
        { model: "REDMI Note 15 5G", memory: 8, storage: 256, ean: "6932554469252", color: "Noir", refund: 30 },
        { model: "REDMI Note 15 5G", memory: 8, storage: 256, ean: "6932554469672", color: "Violet", refund: 30 },
        { model: "REDMI Note 15 5G", memory: 8, storage: 256, ean: "6932554469238", color: "Bleu", refund: 30 },
        { model: "REDMI Note 15 5G", memory: 6, storage: 128, ean: "6932554469245", color: "Noir", refund: 30 },
        { model: "REDMI Note 15 5G", memory: 6, storage: 128, ean: "6932554469658", color: "Violet", refund: 30 },
        { model: "REDMI Note 15 5G", memory: 6, storage: 128, ean: "6932554469696", color: "Bleu", refund: 30 },
        { model: "REDMI Note 15", memory: 8, storage: 256, ean: "6932554476236", color: "Noir", refund: 20 },
        { model: "REDMI Note 15", memory: 8, storage: 256, ean: "6932554482398", color: "Vert", refund: 20 },
        { model: "REDMI Note 15", memory: 8, storage: 256, ean: "6932554482688", color: "Bleu", refund: 20 },
        { model: "REDMI Note 15", memory: 8, storage: 128, ean: "6932554476250", color: "Noir", refund: 20 },
        { model: "REDMI Note 15", memory: 8, storage: 128, ean: "6932554483302", color: "Vert", refund: 20 },
        { model: "REDMI Note 15", memory: 8, storage: 128, ean: "6932554483098", color: "Bleu", refund: 20 },
        { model: "REDMI Note 15", memory: 6, storage: 128, ean: "6932554476281", color: "Noir", refund: 20 },
        { model: "REDMI Note 15", memory: 6, storage: 128, ean: "6932554482947", color: "Vert", refund: 20 },
        { model: "REDMI Note 15", memory: 6, storage: 128, ean: "6932554482701", color: "Bleu", refund: 20 },
      ],
      offers: [
        { model: "Redmi Note 15 Pro+ 5G", refund: 50 },
        { model: "Redmi Note 15 Pro 5G", refund: 40 },
        { model: "Redmi Note 15 5G", refund: 30 },
        { model: "Redmi Note 15", refund: 20 },
      ],
    };
  },
  computed: {
    groupedProducts() {
      const groups = {};
      const modelOrder = [
        "REDMI Note 15 Pro+ 5G",
        "REDMI Note 15 Pro 5G",
        "REDMI Note 15 5G",
        "REDMI Note 15",
      ];

      modelOrder.forEach((modelName) => {
        const modelProducts = this.products.filter((p) => p.model === modelName);
        if (modelProducts.length > 0) {
          groups[modelName] = {
            refund: modelProducts[0].refund,
            products: modelProducts,
          };
        }
      });

      return groups;
    },
  },
  methods: {
    getColorCode(colorName) {
      const colors = {
        Noir: "#1a1a1a",
        Moka: "#8B5A2B",
        Bleu: "#7CB9E8",
        "Gris Titane": "#878681",
        Violet: "#9370DB",
        Vert: "#228B22",
      };
      return colors[colorName] || "#cccccc";
    },
  },
};
</script>
